import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import {
  ShieldCheckIcon,
  GlobeAltIcon,
  ArrowsRightLeftIcon,
} from "@heroicons/react/24/outline";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

Modal.setAppElement("#root");

const CertificateModal = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [pageWidth, setPageWidth] = useState(600);

  // Calculate responsive width on mount and window resize
  useEffect(() => {
    function updatePageWidth() {
      const maxPageWidth = 600;
      const padding = 40;
      const calculatedWidth = window.innerWidth - padding;
      setPageWidth(calculatedWidth > maxPageWidth ? maxPageWidth : calculatedWidth);
    }
    updatePageWidth();
    window.addEventListener("resize", updatePageWidth);
    return () => window.removeEventListener("resize", updatePageWidth);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const openModal = (filePath) => {
    setPdfFile(filePath);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setPdfFile(null);
  };

  return (
    <section id="certificate" className="pb-12 bg-white relative overflow-hidden ">
      <section
        id="Certificate"
        className="max-w-3xl mx-auto px-6 py-8 bg-honeycomb-blue-50 rounded-xl shadow-lg text-center text-lg font-medium text-honeycomb-grey-800 "
      >
        <h2 className="text-3xl font-display font-bold text-honeycomb-blue-700 mb-10 text-center flex items-center justify-center gap-3">
          <ShieldCheckIcon className="w-8 h-8 bg-blue-700 rounded-xl text-white" />
          Certifications & Compliance
        </h2>
        <div className="flex flex-col md:flex-row justify-center gap-8 md:gap-8 ">
          <div className="flex flex-col items-center bg-white border rounded-2xl shadow p-7 w-[320px] h-[240px] ">
            <img
              src="/Documents/Sedex_Logo.png"
              alt="Sedex"
              className="h-9 w-auto mb-4 mt-4 "
            />
            <div className="text-base font-semibold text-gray-800">Audit</div>
            <div className="text-base font-semibold text-gray-800 mb-2">
              Certified
            </div>
            <button
              onClick={() => openModal("/Documents/SEDEX_AUDIT_REPORT.pdf")}
              className="mt-2 text-blue-600 font-medium underline hover:text-blue-800"
            >
              View Certificate
            </button>
          </div>
          <div className="flex flex-col items-center bg-white border rounded-2xl shadow p-7 w-[320px] h-[240px] ">
            <span className="inline-block mb-3">
              <GlobeAltIcon className="w-14 h-14 text-gray-600" />
            </span>
            <div className="text-base font-semibold text-gray-800">Recognized</div>
            <div className="text-base font-semibold text-gray-800 mb-2">
              Export House
            </div>
            <button
              onClick={() => openModal("/Documents/Certificate.pdf")}
              className="mt-2 text-blue-600 font-medium underline hover:text-blue-800"
            >
              View Certificate
            </button>
          </div>
          <div className="flex flex-col items-center bg-white border rounded-2xl shadow p-7 w-[320px] h-[240px] ">
            <span className="inline-block mb-3">
              <ArrowsRightLeftIcon className="w-14 h-14 text-gray-600" />
            </span>
            <div className="text-base font-semibold text-gray-800">Registered</div>
            <div className="text-base font-semibold text-gray-800 mb-2">
              Import/Export Code
            </div>
            <button
              onClick={() => openModal("/Documents/CertificateOfIEC.pdf")}
              className="mt-2 text-blue-600 font-medium underline hover:text-blue-800"
            >
              View Certificate
            </button>
          </div>
        </div>

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Certificate Viewer"
          style={{
            overlay: {
              backgroundColor: "rgba(44, 62, 80, 0.74)",
              zIndex: 1000,
            },
            content: {
              width: "95%",
              maxWidth: "720px",
              height: "80%",
              margin: "auto",
              borderRadius: "26px",
              boxShadow: "0 10px 36px rgba(44, 62, 80, 0.25)",
              border: "6px solid #a78bfa",
              padding: "2rem",
              background: "linear-gradient(135deg, #f9fafb 88%, #ede9fe 100%)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            },
          }}
        >
          <div className="flex justify-between items-center mb-5 border-b pb-3">
            <h2 className="text-xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              Certificate Preview
            </h2>
            <button
              onClick={closeModal}
              className="text-red-500 hover:text-red-700 text-lg font-bold transition"
              title="Close"
            >
              ✕
            </button>
          </div>

          {pdfFile && (
            <div className="flex overflow-y-auto">
              <Document
                file={pdfFile}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={(error) =>
                  console.error("Error loading PDF:", error.message)
                }
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <div key={`page_${index + 1}`} className=" justify-center mb-4">
                    <Page
                      pageNumber={index + 1}
                      width={pageWidth}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                      className="rounded-xl border-4 border-purple-200/80 shadow-xl bg-white"
                    />
                  </div>
                ))}
              </Document>
            </div>
          )}
        </Modal>
      </section>
    </section>
  );
};

export default CertificateModal;
